export default __webpack_public_path__ + "static/media/2.170cb6cc.mov";